import { FC } from 'react'

import { BaseNavbarProps } from '@/components/navbar/Navbar'
import { composeClasses } from '@/utils/compose-classes'
import { OptionButton } from '@/components/buttons/option-button/OptionButton'

export interface InteractionIconsProps {
  interactionIcons: BaseNavbarProps['interactionIcons']
}

const assignedNameIcon = {
  account: 'account_circle',
  notification: 'notifications',
  chat: 'chat_bubble'
} as const
export const InteractionIcons: FC<InteractionIconsProps> = ({
  interactionIcons
}) => {
  return (
    <div className="flex gap-2">
      {interactionIcons?.map((content, index) => {
        let icon = content?.icon

        const nameIcon =
          assignedNameIcon[content?.icon as keyof typeof assignedNameIcon]

        if (typeof content?.icon === 'string') {
          icon = (
            <span className="material-symbols-outlined text-surface-dark">
              {nameIcon}
            </span>
          )
        }

        return (
          <OptionButton
            key={index}
            onlyIcon={icon}
            onClick={content?.onClick}
            className={composeClasses(
              'w-12 h-12 p-3 active:scale-90 transition-transform',
              content?.className
            )}
          />
        )
      })}
    </div>
  )
}
